import { TrackingStatusAnalyticsActionTypes } from './constants';

type TrackingStatusAnalyticsAction = { type: string, payload: {} | string };

export const trackingStatusAnalyticsApiResponseSuccess = (actionType: string, data: any): TrackingStatusAnalyticsAction => ({
    type: TrackingStatusAnalyticsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const trackingStatusAnalyticsApiResponseError = (actionType: string, error: string): TrackingStatusAnalyticsAction => ({
    type: TrackingStatusAnalyticsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const trackingStatusAnalyticsGetNoShipments = (query: string): TrackingStatusAnalyticsAction => ({
    type: TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS,
    payload: { query },
});

export const trackingStatusAnalyticsGetNoShipmentsWithTrackingEvents = (query: string): TrackingStatusAnalyticsAction => ({
    type: TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS_WITH_TRACKING_EVENTS,
    payload: { query },
});

export const trackingStatusAnalyticsGetNoDelivered = (query: string): TrackingStatusAnalyticsAction => ({
    type: TrackingStatusAnalyticsActionTypes.GET_NO_DELIVERED,
    payload: { query },
});

export const trackingStatusAnalyticsGetNoUndelivered = (query: string): TrackingStatusAnalyticsAction => ({
    type: TrackingStatusAnalyticsActionTypes.GET_NO_UNDELIVERED,
    payload: { query },
});

export const trackingStatusAnalyticsGetNoExceptions = (query: string): TrackingStatusAnalyticsAction => ({
    type: TrackingStatusAnalyticsActionTypes.GET_NO_EXCEPTIONS,
    payload: { query },
});

export const trackingStatusAnalyticsGetTrackingStatus = (query: string): TrackingStatusAnalyticsAction => ({
    type: TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS,
    payload: { query },
});

export const trackingStatusAnalyticsGetTrackingStatusByTimeframe = (query: string): TrackingStatusAnalyticsAction => ({
    type: TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_BY_TIMEFRAME,
    payload: { query },
});

export const trackingStatusAnalyticsGetTrackingStatusSummary = (query: string): TrackingStatusAnalyticsAction => ({
    type: TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_SUMMARY,
    payload: { query },
});